import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  scrolled: boolean;
}

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About Us', href: '/about' },
  { label: 'Locations', href: '/locations' },
];

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href: string) => location.pathname === href;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
      scrolled ? 'shadow-md border-b border-gray-100' : 'border-b border-gray-100'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-32">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="block">
              <img
                src="https://storage.readdy-site.link/project_files/1fe59d6f-f04b-46cd-9337-87602fe44c2d/87e17134-81de-4225-99fd-31fa6737ddb3_BT-logo.png?v=9f968b49a8251d6db01111c3dfc346d0"
                alt="British Custom Tailors Logo"
                style={{
                  height: '110px',
                  width: 'auto',
                  display: 'block',
                }}
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors hover:text-[#C9A961] whitespace-nowrap ${
                  isActive(link.href) ? 'text-[#C9A961]' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:866-857-8487" className="flex items-center space-x-2 text-sm font-medium text-gray-700 transition-colors hover:text-[#C9A961] whitespace-nowrap">
              <i className="ri-phone-line text-lg"></i>
              <span>866-857-8487</span>
            </a>
            <Link to="/#consultation" className="bg-[#C9A961] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#B89851] transition-all duration-300 whitespace-nowrap">
              Call for Appointment
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg transition-colors cursor-pointer text-gray-900"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`block font-medium hover:text-[#C9A961] transition-colors whitespace-nowrap ${
                  isActive(link.href) ? 'text-[#C9A961]' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a href="tel:866-857-8487" className="flex items-center space-x-2 text-gray-700 font-medium hover:text-[#C9A961] transition-colors whitespace-nowrap">
              <i className="ri-phone-line"></i>
              <span>866-857-8487</span>
            </a>
            <Link
              to="/#consultation"
              onClick={() => setMobileMenuOpen(false)}
              className="block bg-[#C9A961] text-white px-6 py-3 rounded-full text-center font-semibold hover:bg-[#B89851] transition-all whitespace-nowrap"
            >
              Call for Appointment
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
